var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 355",
    opacity: 0.4,
    d: "M4 7L14 7C16.2091 7 18 8.79086 18 11V15C18 17.2091 16.2091 19 14 19H4C1.79086 19 2.7141e-07 17.2091 1.74846e-07 15L0 11C-9.65645e-08 8.79086 1.79086 7 4 7Z",
    fill: "#7D899C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 345 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46967 4.53033C5.17678 4.23744 5.17678 3.76256 5.46967 3.46967L8.46967 0.46967C8.76256 0.176777 9.23744 0.176777 9.53033 0.46967L12.5303 3.46967C12.8232 3.76256 12.8232 4.23744 12.5303 4.53033C12.2374 4.82322 11.7626 4.82322 11.4697 4.53033L9.75 2.81066L9.75 13C9.75 13.4142 9.41421 13.75 9 13.75C8.58579 13.75 8.25 13.4142 8.25 13L8.25 2.81066L6.53033 4.53033C6.23744 4.82322 5.76256 4.82322 5.46967 4.53033Z",
    fill: "#7D899C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload_file.2ba555ad5292d6f56f558ec77364a639.svg";
export { ForwardRef as ReactComponent };